module.exports = __webpack_public_path__ + "static/media/030.2ac77a0f.jpg";